const TOTAL_ROW_ID = "total_id";

const toolHasEntitiesData = (toolData) => {
  return (
    toolData?.host >= 0 ||
    toolData?.user >= 0 ||
    toolData?.server >= 0 ||
    toolData?.data_store >= 0 ||
    toolData?.app >= 0 ||
    toolData?.nonhuman_identity >= 0
  );
};

export const getRows = (
  dataByTimestamp,
  selectedTimestampIndex,
  orderedTimestamps
) => {
  if (!dataByTimestamp) return [null, null];

  const selectedTimestamp = orderedTimestamps[selectedTimestampIndex];
  const selectedData = dataByTimestamp[selectedTimestamp];

  const previousScanTimestamp =
    selectedTimestampIndex < orderedTimestamps.length - 1
      ? orderedTimestamps[selectedTimestampIndex + 1]
      : null;

  const rows = [];

  for (const [toolName, toolData] of Object.entries(
    selectedData.data_per_tool
  )) {
    if (!toolHasEntitiesData(toolData)) continue;
    const toolTotal = getToolTotalEntities(toolData);

    const toolRow = {
      source: toolName,
      host: toolData?.host || 0,
      user: toolData.user,
      server: toolData?.server || 0,
      data_store: toolData?.data_store || 0,
      app: toolData?.app || 0,
      nonhuman_identity: toolData?.nonhuman_identity || 0,
      total: toolTotal,
    };

    let previousScanToolData = null;
    if (previousScanTimestamp)
      previousScanToolData =
        dataByTimestamp[previousScanTimestamp].data_per_tool[toolName];

    if (previousScanToolData) {
      const previousScanToolTotal = getToolTotalEntities(previousScanToolData);

      toolRow.hostDiff = previousScanToolData.host
        ? toolData.host - previousScanToolData.host
        : null;
      toolRow.userDiff = previousScanToolData.user
        ? toolData.user - previousScanToolData.user
        : null;
      toolRow.serverDiff = previousScanToolData.server
        ? toolData.server - previousScanToolData.server
        : null;
      toolRow.data_storeDiff = previousScanToolData.data_store
        ? toolData.data_store - previousScanToolData.data_store
        : null;
      toolRow.appDiff = previousScanToolData.app
        ? toolData.app - previousScanToolData.app
        : null;
      toolRow.nonhuman_identityDiff = previousScanToolData.nonhuman_identity
        ? toolData.nonhuman_identity - previousScanToolData.nonhuman_identity
        : null;
      toolRow.totalDiff = toolTotal - previousScanToolTotal;
    }
    rows.push(toolRow);
  }
  const totalRow = buildTotalRow(
    selectedData.data_per_tool,
    previousScanTimestamp
      ? dataByTimestamp[previousScanTimestamp].data_per_tool
      : null
  );
  rows.push(totalRow);

  const pinnedRows = {
    bottom: [totalRow],
  };

  return [rows, pinnedRows];
};

const getToolTotalEntities = (toolData) => {
  return (
    toolData?.host ||
    0 + toolData?.user ||
    0 + toolData?.server ||
    0 + toolData?.data_store ||
    0 + toolData?.app ||
    0 + toolData?.nonhuman_identity ||
    0
  );
};

const getEntityTypeTotal = (dataPerTool, entityType) => {
  let total = 0;
  for (const value of Object.values(dataPerTool)) {
    if (value[entityType]) total += value[entityType];
  }
  return total;
};

const buildTotalRow = (dataPerTool, previousScanDataPerTool = null) => {
  const totalRow = {
    source: TOTAL_ROW_ID,
    host: getEntityTypeTotal(dataPerTool, "host"),
    hostDiff: null,
    user: getEntityTypeTotal(dataPerTool, "user"),
    userDiff: null,
    server: getEntityTypeTotal(dataPerTool, "server"),
    serverDiff: null,
    data_store: getEntityTypeTotal(dataPerTool, "data_store"),
    data_storeDiff: null,
    app: getEntityTypeTotal(dataPerTool, "app"),
    appDiff: null,
    nonhuman_identity: getEntityTypeTotal(dataPerTool, "nonhuman_identity"),
    nonhuman_identityDiff: null,
    total: Object.values(dataPerTool).reduce(
      (acc, toolData) => acc + getToolTotalEntities(toolData),
      0
    ),
    totalDiff: null,
  };
  if (previousScanDataPerTool) {
    totalRow.hostDiff =
      totalRow.host - getEntityTypeTotal(previousScanDataPerTool, "host");
    totalRow.userDiff =
      totalRow.user - getEntityTypeTotal(previousScanDataPerTool, "user");
    totalRow.serverDiff =
      totalRow.server - getEntityTypeTotal(previousScanDataPerTool, "server");
    totalRow.data_storeDiff =
      totalRow.data_store -
      getEntityTypeTotal(previousScanDataPerTool, "data_store");
    totalRow.appDiff =
      totalRow.app - getEntityTypeTotal(previousScanDataPerTool, "app");
    totalRow.nonhuman_identityDiff =
      totalRow.nonhuman_identity -
      getEntityTypeTotal(previousScanDataPerTool, "nonhuman_identity");
    totalRow.totalDiff =
      totalRow.total -
      Object.values(previousScanDataPerTool).reduce(
        (acc, toolData) => acc + getToolTotalEntities(toolData),
        0
      );
  }

  return totalRow;
};
